import { render, staticRenderFns } from "./ForeplayAgencyBadgeDark.vue?vue&type=template&id=a79af1ee&scoped=true"
import script from "./ForeplayAgencyBadgeDark.vue?vue&type=script&lang=js"
export * from "./ForeplayAgencyBadgeDark.vue?vue&type=script&lang=js"
import style0 from "./ForeplayAgencyBadgeDark.vue?vue&type=style&index=0&id=a79af1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79af1ee",
  null
  
)

export default component.exports